import Node from 'ln/node/Node';
import Lang from 'ln/lang/Lang';
import DaybreakModel from '../models/DaybreakModel';
import CourseElement from './CourseElement';
import Course from "./Course";
import { scanner } from 'ln/view/Scanner';
import moment from 'moment';
import CoursePreview from './CoursePreview';

class Daybreak extends CourseElement {

	constructor( public model:DaybreakModel, private courseView:Course ) {
		super( model, courseView );
	}
	
	public init() {
		super.init();
		
		// listen for changes
		this.node.js( 'date' ).change.add( this.onDateChange, this );
		this.node.js( 'time' ).change.add( this.onTimeChange, this );
		this.renderTime(this.model.time);
		
		// listen for collapse/expand
		this.node.js( 'toggle' ).click.add( () => {
			this.courseView.toggleDaybreak( this.node );
		});

	}
	
	private onDateChange( n:Node ){

		var pikaday = scanner.first( 'pikaday', this.node );
		if( pikaday ){
			this.model.date = pikaday.toString( 'YYYY-MM-DD' );
			this.courseView.rerenderComputedProperties();
			this.model.save();
			n.value = pikaday.toString('DD.MM.YYYY');
		}

	}
	
	private onTimeChange( n:Node ){
		this.model.time = n.value;
		this.model.save();
		this.renderTime(this.model.time);
		this.courseView.rerenderComputedProperties();
		this.model.course.rerenderDisplayTime.dispatch();
	}

	private renderTime(time:string) {
		let dispTime = moment( this.model.time, ['H:mm'] );
		this.node.one('.display-time').html = dispTime.format( 'H:mm' ) + ' ' + Lang.translate( 'processplan.time' );
	}
	
}

export default Daybreak;